export default "__VITE_ASSET__DmQpwZpu__"